import React from 'react';
import { motion } from 'framer-motion';
import { Star, MapPin } from 'lucide-react';
export function TestimonialsBlock() {
  const testimonials = [{
    initials: 'CR',
    name: 'Claudia R.',
    loc: 'Montevideo',
    pack: 'Sistema Completo + Blindaje',
    text: '"El protocolo para garantes me salvó. Era garante de mi ex marido y terminé con el historial destruido. En 45 días mi nombre estaba limpio."'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    loc: 'Salto',
    pack: 'Sistema Libre de Clearing',
    text: '"Con el script de negociación, en dos llamadas el estudio aceptó el 30% del monto que reclamaban. No lo podía creer."'
  }, {
    initials: 'SC',
    name: 'Sofía C.',
    loc: 'Canelones',
    pack: 'Sistema Libre de Clearing',
    text: '"Mis registros terminaron eliminados en 6 semanas. Eso no pasaba nunca cuando intentaba solucionarlo solo."'
  }, {
    initials: 'PA',
    name: 'Pablo A.',
    loc: 'Maldonado',
    pack: 'Sistema Completo + Blindaje',
    text: '"El protocolo ante llamadas de estudios jurídicos fue un antes y un después. Dejaron de llamar en menos de una semana."'
  }];
  return <section className="py-12 md:py-20 px-4 bg-brand-light border-y border-gold/10" data-id="element-313">
      <div className="max-w-4xl mx-auto" data-id="element-314">
        <div className="text-center mb-12" data-id="element-315">
          <h2 className="text-3xl font-black text-white flex items-center justify-center gap-2" data-id="element-316">
            <span className="text-red-500" data-id="element-317">❤️</span> Más Personas Que Ya Lo
            Tienen
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-318">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-dark border border-gold/20 rounded-2xl p-6 shadow-lg" data-id="element-319">
              <div className="flex items-center justify-between mb-4" data-id="element-320">
                <div className="flex items-center gap-3" data-id="element-321">
                  <div className="w-10 h-10 rounded-full bg-gold-gradient flex items-center justify-center text-brand-dark font-bold text-sm shadow-gold-glow" data-id="element-322">
                    {t.initials}
                  </div>
                  <div data-id="element-323">
                    <div className="flex mb-1" data-id="element-324">
                      {[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 text-gold fill-gold" data-id="element-325" />)}
                    </div>
                    <div className="text-xs text-cream/70 flex items-center gap-1" data-id="element-326">
                      <span className="font-bold text-white" data-id="element-327">{t.name}</span> —{' '}
                      <MapPin className="w-3 h-3 text-gold" data-id="element-328" /> {t.loc}
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-3" data-id="element-329">
                <span className="text-[10px] uppercase tracking-wider bg-brand-green border border-gold/30 text-gold px-2 py-1 rounded" data-id="element-330">
                  {t.pack}
                </span>
              </div>
              <p className="text-cream/90 italic text-sm leading-relaxed" data-id="element-331">
                {t.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}